<template>
  <div class="coursecell">
    <van-list
      v-model="loadingData"
      :finished="finished"
      :finished-text="coursedata.length == 0 ? '暂无课程' : '没有更多了'"
      @load="onLoad"
      :immediate-check="isdo"
    >
      <div
        class="contentCell clearfix"
        v-for="(item, index) in coursedata"
        :key="index"
        @click="clickCell(index)"
      >
        <div
          style="display: inline-block; position: relative"
          class="left_img_box"
        >
          <!-- <img :src="item.appImageUrl" fit="cover" /> -->
          <van-image :src="item.appImageUrl" fit="fill" />
          <div>
            <div class="typeview" v-if="item.type == 'video'">视频</div>
            <div class="typeview" v-else-if="item.type == 'audio'">音频</div>
            <div class="typeview" v-else>文章</div>
          </div>
        </div>

        <div class="rightView">
          <div class="title ov2">{{ item.name }}</div>
          <div class="h17">
            <div class="categoryView" v-show="item.categoryName">
              {{ item.categoryName }}
            </div>
            <!-- <div class="categoryView typeview" v-if="item.type=='video'">视频</div>
                        <div class="categoryView typeview" v-else-if="item.type=='audio'">音频</div>
                        <div class="categoryView typeview" v-else>文章</div> -->
          </div>
          <div class="flex">
            <div class="learnedView">
              <span>{{ item.learnedCount }}</span
              >人学习过
            </div>
            <div class="free" v-if="item.price == 0">限时</div>
            <div class="priceView" v-else>
              {{ item.price + "元" }}
            </div>
          </div>
        </div>
      </div>
      <van-empty
        v-if="coursedata.length == 0 && !loadingData"
        :image="require('../../assets/img/none.png')"
      />
    </van-list>
  </div>
</template>

<script>
import { List } from "vant";
export default {
  name: "coursecell",
  data() {
    return {
      loadingData: false,
    };
  },

  props: {
    coursedata: {
      default: {},
    },
    loading: false,
    finished: false,
    isdo: true,
  },
  watch: {
    // <van-list v-model="loading"  属于双向绑定。子组件不能改变props的值，会报错。在data上弄个副本值
    loading(newVal) {
      console.log("000000", newVal);
      this.loadingData = newVal;
    },
  },

  methods: {
    clickCell(index) {
      console.log("jiojojoj", index);
      this.$emit("watchCourse", index);
    },
    //上拉加载数据
    onLoad() {
      this.$emit("footerRefresh");
    },
  },
};
</script>

<style  lang="less">
.coursecell {
  .clearfix:after {
    content: " ";
    display: block;
    clear: both;
    line-height: 0;
    height: 0;
  }
  .free {
    width: 40px;
    height: 20px;
    line-height: 19px;
    border-radius: 50px;
    background-color: rgba(229, 240, 249, 100);
    color: rgba(32, 139, 238, 100);
    font-size: 12px;
    text-align: center;
    font-family: -apple-system;
    border: 1px solid rgba(32, 139, 238, 100);
  }
  .contentCell {
    position: relative;
    width: 100%;
    border-top: 1px solid @gray-light;
    padding: 12px 0;

    img {
      width: 100%;
      height: 100%;
    }
    .left_img_box {
      width: 134px;
      height: 88px;
      border-radius: 4px;
      font-size: 12px;
      overflow: hidden;
      .van-image {
        width: 100%;
        height: 100% !important;
      }
    }
    span {
      color: white;
    }
    .rightView {
      padding: 0 11px 0 0;
      margin: 0;
      float: right;
      height: 100%;
      width: 176px;
      .title {
        font-size: @font-title;
        color: @black;
        // font-weight: bold;
        width: 100%;
        height: 44px;
        line-height: 22px;
      }
      .categoryView {
        background-color: @orange;
        width: 51px;
        height: 17px;
        line-height: 17px;
        border-radius: 2px;
        text-align: center;
        font-size: @font-size-xs;

        color: white;
        display: inline-block;
      }

      .learnedView {
        color: @orange;
        font-size: @font-size-sm;
        color: @detail-color;
        span {
          color: @orange;
        }
      }
      .priceView {
        // position: absolute;
        // right: 0;
        // bottom: 10px;
        color: @red-dark;
        font-size: 16px;
      }
    }
    .typeview {
      width: 46px;
      height: 17px;
      background-color: rgba(15, 15, 18, 65);
      color: #fff;
      position: absolute;
      font-size: 12px !important;
      text-align: center;
      font-family: -apple-system;
      line-height: 17px;
      bottom: 4px;
      left: 13px;
      border-radius: 10px;
      border: 1px solid #fff;
    }
    .h17 {
      height: 17px;
      margin: 8px 0 6px 0;
    }
  }
  .van-empty .van-empty__image {
    width: 192px !important;
    height: 128px !important;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: baseline;
  }
}
</style>